import React, {Dispatch, SetStateAction} from 'react'
import Select from 'react-select'
import {toAbsoluteUrl} from '../../../../../_metronic/helpers'

const CustomSearchSelectInput = ({
  options,
  field,
  form,
  disable,
  setTemplateId,
}: {
  options: {id: number; label: string; value: number | string}
  field: any
  form: any
  disable: boolean
  setTemplateId?: Dispatch<SetStateAction<number | undefined>>
}) => {
  const DropdownIndicator = () => {
    return (
      <div className='me-3'>
        <img src={toAbsoluteUrl('/media/icons/investor/search.svg')} alt='search' />
      </div>
    )
  }

  const customStyles = {
    placeholder: (provided: any, state: any) => ({
      ...provided,
      fontSize: 13,
      fontWeight: 500,
    }),
    input: (provided: any, state: any) => ({
      ...provided,
      fontSize: 13,
    }),
  }
  const handleChange = (selectedOption: {id: number; label: string; value: number | string}) => {
    form.setFieldValue(field.name, selectedOption)
    if (setTemplateId) {
      setTemplateId(selectedOption.value as number)
    }
  }
  return (
    <Select
      {...field}
      components={{DropdownIndicator}}
      styles={customStyles}
      isSearchable={true}
      classNamePrefix='react-select'
      options={options}
      onChange={handleChange}
      value={field.value}
      isDisabled={disable}
    />
  )
}

export default CustomSearchSelectInput
